// female result page revamp faq section code
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".faq-question-answer details")
    .forEach((detail) => {
      detail.addEventListener("toggle", function () {
        const icon = this.querySelector(".faq-icon");
        if (this.open) {
          icon.textContent = "-";
        } else {
          icon.textContent = "+";
        }
      });
    });
});